import { OnboardingScreen } from "@/interactors/OnboardingScreen";

export default function Onboarding() {
  return <OnboardingScreen />;
}
